import React, { useState, useEffect } from 'react';
import * as adminApi from '../../services/adminApi';
import './UsersList.css';

const UsersList = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [newUser, setNewUser] = useState({
        login: '',
        password: '',
        name: '',
        email: '',
        personal_phone: ''
    });

    useEffect(() => {
        loadUsers();
    }, []);

    const loadUsers = async () => {
        try {
            setLoading(true);
            const data = await adminApi.getUsers();
            setUsers(data);
            setError(null);
        } catch (err) {
            console.error('Error loading users:', err);
            setError('Не удалось загрузить список пользователей');
        } finally {
            setLoading(false);
        }
    };

    const handleToggleActive = async (id) => {
        try {
            await adminApi.toggleUserActive(id);
            loadUsers();
        } catch (err) {
            alert('Ошибка при изменении статуса пользователя');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Вы уверены, что хотите удалить этого пользователя?')) return;
        try {
            await adminApi.deleteUser(id);
            loadUsers();
        } catch (err) {
            alert(err.response?.data?.error || 'Ошибка при удалении пользователя');
        }
    };

    const handleCreateUser = async (e) => {
        e.preventDefault();
        try {
            await adminApi.createUser(newUser);
            setShowAddModal(false);
            setNewUser({ login: '', password: '', name: '', email: '', personal_phone: '' });
            loadUsers();
        } catch (err) {
            alert(err.response?.data?.error || 'Ошибка при создании пользователя');
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('ru-RU') + ' ' + date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
    };

    if (loading) return <div className="admin-loading">Загрузка...</div>;

    return (
        <div className="admin-users-list">
            <div className="list-header">
                <h2>Пользователи</h2>
                <div className="header-actions">
                    <button className="btn-add" onClick={() => setShowAddModal(true)}>+ Добавить пользователя</button>
                    <button className="btn-refresh" onClick={loadUsers}>Обновить</button>
                </div>
            </div>

            {error && <div className="admin-error">{error}</div>}

            <div className="table-container">
                <table className="admin-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Логин</th>
                            <th>Имя</th>
                            <th>Email</th>
                            <th>Телефон</th>
                            <th>Регистрация</th>
                            <th>Активен</th>
                            <th>Действия</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id}>
                                <td>{user.id}</td>
                                <td className="col-login">{user.login}</td>
                                <td>{user.name || '-'}</td>
                                <td>{user.email || '-'}</td>
                                <td>{user.personal_phone || '-'}</td>
                                <td>{formatDate(user.date_register)}</td>
                                <td>
                                    <span
                                        className={`status-badge ${user.active === 'Y' ? 'active' : 'inactive'}`}
                                        onClick={() => handleToggleActive(user.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        {user.active === 'Y' ? 'Да' : 'Нет'}
                                    </span>
                                </td>
                                <td className="actions">
                                    <button
                                        className="btn-delete"
                                        onClick={() => handleDelete(user.id)}
                                        disabled={user.id === 1}
                                    >
                                        Удалить
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {users.length === 0 && <div className="empty-state">Пользователей не найдено</div>}
            </div>

            {showAddModal && (
                <div className="modal-overlay">
                    <div className="admin-modal">
                        <h3>Добавить нового пользователя</h3>
                        <form onSubmit={handleCreateUser}>
                            <div className="form-group">
                                <label>Логин *</label>
                                <input
                                    type="text"
                                    value={newUser.login}
                                    onChange={(e) => setNewUser({ ...newUser, login: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Пароль *</label>
                                <input
                                    type="password"
                                    value={newUser.password}
                                    onChange={(e) => setNewUser({ ...newUser, password: e.target.value })}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Имя</label>
                                <input
                                    type="text"
                                    value={newUser.name}
                                    onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label>Email</label>
                                <input
                                    type="email"
                                    value={newUser.email}
                                    onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <label>Телефон</label>
                                <input
                                    type="text"
                                    value={newUser.personal_phone}
                                    onChange={(e) => setNewUser({ ...newUser, personal_phone: e.target.value })}
                                />
                            </div>
                            <div className="modal-actions">
                                <button type="button" className="btn-cancel" onClick={() => setShowAddModal(false)}>Отмена</button>
                                <button type="submit" className="btn-save">Создать</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UsersList;
